module.exports = __webpack_public_path__ + "img/home_license.81e051ea.png";